import {
    DOCUMENT_IMPORT,
    DOCUMENT_METADATA,
    DOCUMENT_VIEWS,
    CLEAR_ERRORS,
    DOCUMENT_MARKUP
} from '@Constants/types';
import { DocumentStatus } from '@Constants/status';

const initialState = {
    documentId: '',
    jobId: '',
    userViews: [],
    metadata: {},
    documentStatus: DocumentStatus.NOT_SUBMITTED,
    base64str: '',
    mappedParagraphsScorecard: [],
    mappedParagraphsScorecard2: [],
    mappedParagraphsLabels: [],
    mappedParagraphsLabels2: [],
    overlapMap: [],
    markupDetails: [],
    markupDetailsTimeStamp: null,
    overlapMapReady: false,
    contentControlClicked: false,
    showMisses: false,
    remainingItems: 0,
    totalItems: 0,
    staleStatus: '',
    staleResult: '',
    trackChangesEnabled: false,
    markUpInProgress: 'NotStarted',
    clickEventHandlersApplied: false,
    isMarkupCancelling: false,
    processingDialogVisible: false,
    trackChangesCheckingEnabled: true,
    isMarkupFailed: false,
    selectedContentControl: null,
    ismarkupDetailsVisible: false,
    searchCount: 0,
    lastCount: 0
};

export default function documentReducer(state = initialState, action) {
    switch (action.type) {
        case CLEAR_ERRORS:
            return { ...state, serverResponse: '' };

        case DOCUMENT_MARKUP.BASE64_DATA:
            return {
                ...state,
                base64str: action.payload
            };

        case DOCUMENT_MARKUP.BACKGROUND_PROCESS_SCORECARD:
            return {
                ...state,
                mappedParagraphsScorecard: action.payload.mappedParagraphs,
                mappedParagraphsScorecard2: action.payload.mappedParagraphs2
            };

        case DOCUMENT_MARKUP.OVERLAP_MAP:
            return {
                ...state,
                overlapMap: action.payload,
                overlapMapReady: true
            };

        case DOCUMENT_MARKUP.SEARCH_COUNT:
            return {
                ...state,
                searchCount: action.payload
            };

        case DOCUMENT_MARKUP.SET_LAST_COUNT:
            return {
                ...state,
                lastCount: action.payload
            };

        case DOCUMENT_MARKUP.MARKUP_DETAILS:
            return {
                ...state,
                markupDetails: action.payload,
                markupDetailsTimeStamp: new Date()
            };
        case DOCUMENT_MARKUP.BACKGROUND_PROCESS_LABELS:
            return {
                ...state,
                mappedParagraphsLabels: action.payload.mappedParagraphs,
                mappedParagraphsLabels2: action.payload.mappedParagraphs2,
                showMisses: action.payload.showMisses
            };

        case DOCUMENT_MARKUP.CLEAR_BACKGROUND_PROCESS_DATA:
            return {
                ...state,
                mappedParagraphsScorecard: [],
                mappedParagraphsScorecard2: [],
                mappedParagraphsLabels: [],
                mappedParagraphsLabels2: [],
                remainingItems: 0
            };

        case DOCUMENT_MARKUP.SET_TOTAL_ITEMS:
            return {
                ...state,
                totalItems: action.payload
            };

        case DOCUMENT_MARKUP.MARKUP_PROGRESS:
            return {
                ...state,
                remainingItems: action.payload
            };
        case DOCUMENT_MARKUP.MARKUP_FAILURE:
            return {
                ...state,
                isMarkupFailed: action.payload
            };

        case DOCUMENT_MARKUP.MARKUP_CANCEL_FLAG:
            return {
                ...state,
                isMarkupCancelling: action.payload
            };

        case DOCUMENT_MARKUP.PROCESSING_DIALOG_VISIBLE:
            return {
                ...state,
                processingDialogVisible: action.payload
            };

        case DOCUMENT_MARKUP.MARKUP_RUNNING:
            return {
                ...state,
                markUpInProgress: action.payload
            };

        case DOCUMENT_MARKUP.MARKUP_EVENTS_APPLIED:
            return {
                ...state,
                clickEventHandlersApplied: action.payload
            };

        case DOCUMENT_MARKUP.CHECK_STALE_STATUS:
            return {
                ...state,
                staleStatus: action.payload.staleStatus,
                staleResult: action.payload.staleResult
            };

        case DOCUMENT_MARKUP.TRACK_CHANGES:
            return {
                ...state,
                trackChangesEnabled: action.payload
            };

        case DOCUMENT_MARKUP.TRACK_CHANGES_CHECKING_ENABLED:
            return {
                ...state,
                trackChangesCheckingEnabled: action.payload
            };

        case DOCUMENT_MARKUP.CONTENT_CONTROL_SELECTED:
            return {
                ...state,
                selectedContentControl: action.payload,
                contentControlClicked: true
            };
        case DOCUMENT_MARKUP.RESET_CLICK_FLAG:
            return {
                ...state,
                contentControlClicked: false
            };

        case DOCUMENT_IMPORT.IMPORT_REQUEST:
            return { ...state, isSubmitting: true, documentStatus: DocumentStatus.INITIALIZING };
        case DOCUMENT_IMPORT.IMPORT_SUCCESS:
            return {
                ...state,
                documentId: action.payload.documentId,
                jobId: action.payload.jobId,
                isSubmitting: true,
                documentStatus: DocumentStatus.PENDING
            };
        case DOCUMENT_IMPORT.IMPORT_FAILURE:
            return {
                ...state,
                isSubmitting: false,
                documentStatus: DocumentStatus.NOT_SUBMITTED,
                metadata: {}
            };

        case DOCUMENT_IMPORT.IMPORT_ERROR:
            return {
                ...state,
                isSubmitting: false,
                documentStatus: DocumentStatus.NOT_SUBMITTED,
                metadata: {}
            };
        case DOCUMENT_METADATA.FETCH_METADATA_REQUEST:
            return {
                ...state,
                isSubmitting: !action.payload.refresh,
                documentStatus: action.payload.refresh
                    ? DocumentStatus.PROCESSED
                    : DocumentStatus.PENDING
            };
        case DOCUMENT_METADATA.FETCH_METADATA_SUCCESS:
            return {
                ...state,
                metadata: action.payload.metadata,
                importedAt: action.payload.importedAt,
                isSubmitting: false,
                documentStatus: DocumentStatus.PROCESSED
            };
        case DOCUMENT_METADATA.FETCH_METADATA_CANCELLED:
            return {
                ...state,
                isSubmitting: false,
                documentStatus: DocumentStatus.NOT_SUBMITTED,
                metadata: {}
            };
        case DOCUMENT_METADATA.FETCH_METADATA_FAILURE:
            return {
                ...state,
                isSubmitting: false,
                documentStatus: DocumentStatus.NOT_SUBMITTED,
                metadata: {}
            };
        case DOCUMENT_METADATA.FETCH_METADATA_ERROR:
            return {
                ...state,
                isSubmitting: false,
                documentStatus: DocumentStatus.NOT_SUBMITTED,
                metadata: {}
            };
        case DOCUMENT_VIEWS.DOCUMENT_VIEWS_SUCCESS:
            return { ...state, userViews: action.payload };
        // On system change
        case DOCUMENT_METADATA.SWITCH_SYSTEM:
            return {
                ...state,
                mappedParagraphsScorecard: [],
                mappedParagraphsLabels: [],
                documentStatus: action.payload.isSubmitted
                    ? DocumentStatus.PROCESSED
                    : DocumentStatus.NOT_SUBMITTED
            };

        case DOCUMENT_MARKUP.TOGGLE_MARKUP_DETAILS:
            return { ...state, isMarkupDetailsVisible: action.payload };
        case DOCUMENT_VIEWS.CLEAR_VIEWS:
            return { ...state, userViews: [] };

        case DOCUMENT_VIEWS.CLEAR_LABELS:
            return { ...initialState };
        default:
            return state;
    }
}
